export default {
  key: "privilege",
  fields: [
    { key: "id" },
    { key: "name" },
    { key: "enable_flag", type: "boolean" },
    { type: "action-btn" },
  ],
  structure: [
    ["name"],
    ["enable_flag"]
  ],
  sort: {
    field: "id",
    order: "asc"
  },
  default: {
    enable_flag: 1
  },
  action: ["create","edit"]
}